require('es6-promise').polyfill();

import '../scss/styles.scss';
import 'jquery/dist/jquery.js';
import 'bootstrap/dist/js/bootstrap.js';
import 'jquery-match-height/dist/jquery.matchHeight.js';
import 'bxslider/dist/jquery.bxslider.js';
import 'bxslider/dist/jquery.bxslider.js';
import './slick.min.js';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

import Homepage from './Homepage';
import ProjectsPage from './ProjectsPage';
import ProjectPage from './ProjectPage';
import ContactPage from './ContactPage';
import Config from './Config';

function initBackgroundImage() {
    $('[data-background]').each(function(index, el) {
        $(el).css('background-image', 'url(' + $(el).data('background') + ')');
    });
}

$(document).ready(function($) {
    var removeLoader = true;

    new Homepage();

    $('h2.decorated').each(function(index, el) {
        var $span = $(el).find('span')
        if(!$span.length){
            $(el).html('<span>' + $(el).html() + '</span>')
        }
    });

    $('button[data-href]').on('click', function(){
        window.location.href = $(this).data('href');
    });

    $('[data-toggle="readmore"]').on('click', function(event) {
        if ($(this).hasClass('opened')) {
            $($(this).data('target')).slideUp()
            $(this).removeClass('opened').text($(this).data('read-more'))
        } else {
            $($(this).data('target')).slideDown()
            $(this).addClass('opened').text($(this).data('read-less'))
        }
        event.stopImmediatePropagation();
        event.preventDefault()
        return false
    })

    $('body').on('click', '[data-project]', function(event) {

        let projectId  = $(this).data('project')

        Config.showPageLoader()

        $.post($('body').data('ajax'), {
            action: 'load_project_modal',
            id: projectId
        }, function(data, textStatus, xhr) {

            if(data.success){

                $('#projectModal .project-description').html(data.project.content)
                $('#projectModal .project-title span').html(data.project.title)
                $('#projectModal .carousel-inner').empty()

                $.each(data.project.images, function(index, image) {

                    var imageUrl = image.sizes && image.sizes['fs-size'] ? image.sizes['fs-size'] : '';

                    if(imageUrl){
                        $('#projectModal .carousel-inner').append('<div class="item ' + (index == 0 ? 'active' : '') + '" style="background-image:url(' + imageUrl + ')"></div>')
                    }
                });

                setTimeout(function(){
                    jQuery('#projectCarousel').carousel({
                        interval: false,
                        wrap: false
                    })
                }, 500)

                $('#projectModal').addClass('modal-loading').modal('show')

                jQuery('#projectCarousel').unbind('slid.bs.carousel').on('slid.bs.carousel', function() {

                    jQuery('#projectCarousel .carousel-control').hide();

                    var noControls = true

                    if(!jQuery('#projectCarousel .carousel-inner .item:first').hasClass('active')) {
                        jQuery('#projectCarousel .left.carousel-control').show();
                        noControls= false
                    }
                    if(!jQuery('#projectCarousel .carousel-inner .item:last').hasClass('active')) {
                        jQuery('#projectCarousel .right.carousel-control').show();
                        noControls = false
                    }

                    if(noControls){
                        jQuery('#projectCarousel .carousel-controls').hide();
                    }
                    else{
                        jQuery('#projectCarousel .carousel-controls').show();
                    }

                }).trigger('slid.bs.carousel')

            }

            Config.removePageLoader();
        })

        event.preventDefault();

        return false
    });

    if($('.page-template-page-expertises').length){

        $('.nav-pills-squares li a').on('click', function(event) {

            if($(window).width() < 768){

                if($(this).closest('li').hasClass('active')){
                    $(this).closest('li').removeClass('active')
                    event.preventDefault();
                    return false
                }

            }

        })

        if($(window).width() > 768){
            $('.nav-pills-squares li a').first().click()
        }
        else{
            $('.nav-pills-squares li').each(function(index, el) {
                $(el).find('h2').first().addClass('decorated-title')
                $(el).find('h2').first().html('<span>' + $(el).find('h2').first().text() + '</span>')
            })
        }
    }

    if($('.page-template-page-about').length){

        var $element = jQuery('.clients-logos-slider')

        var $backupItems = $element.find('.item').clone()

        $element.empty()

        try{
            $element.slick('unslick');
        }
        catch(e){

        }

        $element.empty()

        var settings = {
            itemsperslide : $(window).width() > 768 ? 18 : 3
        }

        var itemsPages = Math.ceil($backupItems.length / settings.itemsperslide)

        for(var i = 0; i < itemsPages; i++){

            var $page = jQuery('<div>').addClass('clients-logos-slide')

            var $pageContainer = jQuery('<div>').addClass('clients-logos')

            $page.append($pageContainer)

            var startAt = i * settings.itemsperslide
            var endAt = i * settings.itemsperslide + settings.itemsperslide

            jQuery.each($backupItems.slice(startAt, endAt), function(elementIndex, elementObject) {
                $pageContainer.append(jQuery(elementObject).clone())
            })

            $element.append($page)
        }

        $element.slick({
            infinite:false,
            rtl: false
        })
    }

    if ($('#contactMap').length) {
        new ContactPage();
        removeLoader = false;
    }

    if ($('body').hasClass('page-template-page-projects')) {
        new ProjectsPage();
    }

    if ($('#projectMap').length) {
        new ProjectPage();
        removeLoader = false;
    }

    initBackgroundImage();

    if (removeLoader) {
        setTimeout(function() {
            Config.removePageLoader();
        }, 500)
    }
});



// WEBPACK FOOTER //
// src/scripts/index.js